import daysjs from 'dayjs'

export const shouldDisplayDnacpr = (
  dnacpr?: boolean,
  dnacprStartDate?: string | null
) => {
  if (!dnacpr) return false
  if (!dnacprStartDate) return true
  return daysjs().isAfter(dnacprStartDate)
}
